/**
 * Checks if an image exists and is valid.
 * @param {string} imageUrl - The image URL to check.
 * @returns {Promise<boolean>} - Resolves to the provided image url if the image exists, false otherwise.
 */
export async function resolveImage (imageUrl) {
  if (!imageUrl) return false

  // Handle relative URLs (e.g., Laravel public paths)
  let url = imageUrl
  if (imageUrl) {
    url = `${window.location.origin}${imageUrl}`
  }

  return new Promise((resolve) => {
    const img = new Image()

    img.onload = () => {
      resolve(imageUrl)
    }

    img.onerror = () => {
      resolve(false)
    }

    img.src = url
  })
}
